import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaWhatsapp } from 'react-icons/fa';
import PickerModal from '../components/PickerModal';
import { LANGUAGES } from '../data/languages';
import { STATES } from '../data/states';
import { PHONE } from '../config';
import '../mobile.css';

const generatePassword = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let out = '';
  for (let i = 0; i < 8; i++) out += chars[Math.floor(Math.random() * chars.length)];
  return out;
};

const isIndianMobile = (s) => /^[6-9]\d{9}$/.test(s);

const MobileRegister = ({ API_URL }) => {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [designation, setDesignation] = useState('');
  const [mobile, setMobile] = useState('');
  const [nativeLanguage, setNativeLanguage] = useState('');
  const [state, setState] = useState('');
  const [password] = useState(generatePassword());
  const [loading, setLoading] = useState(false);
  const [showLanguagePicker, setShowLanguagePicker] = useState(false);
  const [showStatePicker, setShowStatePicker] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successPopup, setSuccessPopup] = useState(false);
  const [showTermsConfirm, setShowTermsConfirm] = useState(false);

  const isValidMobile = isIndianMobile(mobile);
  const isDisabled = loading || !firstName || !lastName || !designation || !nativeLanguage || !state || !isValidMobile;

  const handleMobileChange = (e) => {
    setMobile((e.target.value || '').replace(/\D/g, '').slice(0, 10));
  };

  const handleRegister = async () => {
    setLoading(true);
    setErrorMessage('');

    try {
      await axios.post(`${API_URL}/user`, {
        firstName,
        lastName,
        email: mobile,
        mobile,
        accountType: 'Police',
        password,
        designation,
        nativeLanguage,
        state,
      });
      setShowTermsConfirm(false);
      setSuccessPopup(true);
    } catch (error) {
      setShowTermsConfirm(false);
      setErrorMessage(error?.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const message = 'Hello, I need help with LegalApp.';
  const waLink = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

  return (
    <div>
      <h1 style={{ fontSize: '24px', fontWeight: 600, textAlign: 'center', marginBottom: '20px' }}>Register</h1>

      <input
        placeholder="First Name"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />
      <input
        placeholder="Last Name"
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />
      <input
        placeholder="Designation"
        value={designation}
        onChange={(e) => setDesignation(e.target.value)}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />
      <input
        placeholder="Mobile"
        value={mobile}
        inputMode="numeric"
        onChange={handleMobileChange}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />

      <div
        onClick={() => setShowLanguagePicker(true)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px', cursor: 'pointer' }}
      >
        <span style={{ color: nativeLanguage ? '#000' : '#999' }}>{nativeLanguage || 'Preferred Language'}</span>
        <span style={{ color: '#0A426A', fontWeight: 600 }}>Select</span>
      </div>

      <div
        onClick={() => setShowStatePicker(true)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px', cursor: 'pointer' }}
      >
        <span style={{ color: state ? '#000' : '#999' }}>{state || 'State'}</span>
        <span style={{ color: '#0A426A', fontWeight: 600 }}>Select</span>
      </div>

      <button onClick={() => setShowTermsConfirm(true)} disabled={isDisabled} className="m-button-primary">
        {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Register'}
      </button>

      <p style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          type="button"
          onClick={() => navigate('/m/login')}
          className="m-pill-btn"
          style={{ color: '#094268', fontWeight: 600 }}
        >
          Already have an account? Login
        </button>
      </p>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '-5px' }}>
        <a href="/m/terms" target="_blank" rel="noopener noreferrer" className="m-pill-btn" style={{ color: '#094268' }}>Terms of Use</a>
        <a href="/m/privacy" target="_blank" rel="noopener noreferrer" className="m-pill-btn" style={{ color: '#094268' }}>Privacy Policy</a>
      </div>

      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', width: 'fit-content', margin: '10px auto 0', padding: '10px 14px', borderRadius: '30px', border: '1px solid #062F4A', textDecoration: 'none', color: '#0A426A', fontSize: '12px' }}
      >
        <FaWhatsapp size={18} color="#25D366" />
        +91 9217224586
      </a>

      {showLanguagePicker && (
        <PickerModal
          title="Preferred Language"
          options={LANGUAGES}
          selected={nativeLanguage}
          onSelect={setNativeLanguage}
          onClose={() => setShowLanguagePicker(false)}
        />
      )}

      {showStatePicker && (
        <PickerModal
          title="State"
          options={STATES}
          selected={state}
          onSelect={setState}
          onClose={() => setShowStatePicker(false)}
        />
      )}

      {showTermsConfirm && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Confirm</h3>
            <p>I accept the Terms of Use and Privacy Policy.</p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setShowTermsConfirm(false)} className="m-pill-btn" style={{ color: '#094268', fontWeight: 600 }} disabled={loading}>Cancel</button>
              <button className="m-button-primary" style={{ width: 'auto', padding: '8px 14px' }} onClick={handleRegister} disabled={loading}>
                {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Accept'}
              </button>
            </div>
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Error</h3>
            <p>{errorMessage}</p>
            <button className="m-button-primary" onClick={() => setErrorMessage('')}>OK</button>
          </div>
        </div>
      )}

      {successPopup && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Success</h3>
            <p>Registration successful. Please log in.</p>
            <button className="m-button-primary" onClick={() => navigate('/m/login')}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileRegister;
